import request from '@/utils/request'
import { buildErpHistoryItemsUrl, buildErpHistorySummariesUrl } from './endpoints'
import { toRepeatQuery } from './queryString'
import { ErpHistoryItem, ErpHistorySummary, GetErpHistoriesReq, GetGoodsCodeOptionsReq, GetStyleNumberOptionsReq, GoodsCodeOption, StyleNumberOptionItem } from './types'

export {
  ERP_HISTORIES_URL,
  ERP_HISTORY_SUMMARIES_URL,
  ERP_HISTORY_SUMMARIES_EXCEL_URL,
  ERP_HISTORY_ITEMS_EXCEL_URL,
  buildErpHistorySummariesExcelUrl,
  buildErpHistoryItemsExcelUrl,
} from './endpoints'

/**
 * EST05(신규) 재고이동내역조회 화면의 보조 엔드포인트. 주 배선(조회/다운로드)은 endpoints.ts 참조.
 *
 * 보조 조회 2건은 서치헬퍼용이다(버튼 동작 아님):
 * - 상품코드 서치헬퍼 `GET /api/v1/master/products/goods-codes` — LOGISPRD-9955 (2.0)
 * - 스타일넘버 서치헬퍼 `GET /api/v1/master/products/style-numbers` — LOGISPRD-14184 (2.0, 1.0 grid/search STL_NO 대체)
 */
export const GOODS_CODE_OPTIONS_URL = '/api/v1/master/products/goods-codes'
export const STYLE_NUMBER_OPTIONS_URL = '/api/v1/master/products/style-numbers'

/**
 * EST03 HEAD(재고이동내역 문서 헤더) 조회. (LOGISPRD-9590)
 *
 * 서버 페이징 없이 조건에 걸린 전건이 List 로 온다(1.0 동등). 무결과는 HTTP 200 + 빈 배열.
 * HEAD 는 무필터 가드가 없지만 화면은 화주명·마감일자 필수(디자인)라 무필터에 도달하지 않는다.
 */
export const getErpHistorySummaries = (params: GetErpHistoriesReq) =>
  request.get<ApiResponseV2<{ items: ErpHistorySummary[] }>>(buildErpHistorySummariesUrl(params))

/**
 * EST03 ITEM(재고이동내역 문서 상세) 조회. (LOGISPRD-9590)
 *
 * BE 는 검색조건 1개 이상을 요구한다(WEB_STO_DETAIL 전건 스캔 방지) — 화면 필수 필터가 이를 보장한다.
 */
export const getErpHistoryItems = (params: GetErpHistoriesReq) =>
  request.get<ApiResponseV2<{ items: ErpHistoryItem[] }>>(buildErpHistoryItemsUrl(params))

/**
 * 상품코드 서치헬퍼 목록. (LOGISPRD-9955 — 1.0 `GDS_CD_SearchForm` 이관)
 *
 * 무페이징 distinct 목록이라 응답 전건이 모달 그리드에 실린다. 화주로 범위를 좁혀 조회한다.
 */
export const getGoodsCodeOptions = (params: GetGoodsCodeOptionsReq) =>
  request.get<ApiResponseV2<{ items: GoodsCodeOption[] }>>(`${GOODS_CODE_OPTIONS_URL}?${toRepeatQuery(params)}`)

/**
 * 스타일넘버 서치헬퍼 목록. (LOGISPRD-14184 — 1.0 `STL_NO_SearchForm` 대체)
 *
 * master_item distinct (스타일번호·브랜드명·상품코드), 스타일번호 오름차순, 최대 1,000행. 0건은 HTTP 200 + 빈 목록이다.
 * 브랜드명은 부분일치로 서버가 거르고, 스타일번호는 BE 가 정확일치라 화면이 받은 목록을 부분일치로 거른다.
 */
export const getStyleNumberOptions = (params: GetStyleNumberOptionsReq) =>
  request.get<ApiResponseV2<{ items: StyleNumberOptionItem[] }>>(`${STYLE_NUMBER_OPTIONS_URL}?${toRepeatQuery(params)}`)
